
import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = sanityClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: 'production',
    // use current UTC date - see "specifying API version"!
    apiVersion: '2021-11-16',
    // or leave blank for unauthenticated usage
    token: process.env.REACT_APP_SANITY_TOKEN,
    // `false` if you want to ensure fresh data
    useCdn: 'true',
})
//passing the imageUrlBuilder to the client 
const builder = imageUrlBuilder(client)

export const urlFor = (source) => builder.image(source)